import lazyPage from "../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/pages/home/TaskTypes/TaskTypes.tsx",
    () => import("./TaskTypes"),
);
